import Link from "next/link";
import Button from "components/shared/button/Button";
import { ExtraInfoStyled, Text } from "./ExtraInfo.styled";

export default function ExtraInfo() {
    return (
        <ExtraInfoStyled>
            <Text>
                Bekijk de{" "}
                <Link href="/algemene-voorwaarden" passHref>
                    <Button element="a" variant="ghost">
                        algemene voorwaarden
                    </Button>
                </Link>{" "}
                van Premium Cards B.V.
            </Text>
        </ExtraInfoStyled>
    );
}
